import type { Variants, Transition } from 'framer-motion'

export const springTransition: Transition = { type: 'spring', stiffness: 350, damping: 28 }

export const listVariants: Variants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.1 },
  },
}

export const itemVariants: Variants = {
  hidden: { opacity: 0, y: 15 },
  show: { opacity: 1, y: 0, transition: springTransition },
}
